import React from "react";
import { Box, Typography, Divider } from "@mui/material";
import { Email } from "@mui/icons-material";

const AccountMetadataCard = ({ user }) => {
  return (
    <Box
      sx={{
        border: "1px solid",
        borderColor: "divider",
        borderRadius: 2,
        p: 2.5,
        height: "100%",
        bgcolor: "background.paper",
      }}
    >
      <Box sx={{ display: "flex", alignItems: "center", gap: 1.5, mb: 2 }}>
        <Email sx={{ color: "primary.main" }} />
        <Typography variant="subtitle1" fontWeight={600}>
          Account Metadata
        </Typography>
      </Box>
      <Divider sx={{ mb: 2 }} />

      <Box sx={{ display: "flex", flexDirection: "column", gap: 1.5 }}>
        <Typography variant="body2">
          <strong>Status:</strong>{" "}
          {user?.status
            ? user.status.charAt(0).toUpperCase() + user.status.slice(1)
            : "—"}
        </Typography>
        <Typography variant="body2">
          <strong>Email Verified:</strong> Yes
        </Typography>
        <Typography variant="body2">
          <strong>Joined:</strong>{" "}
          {user?.createdAt ? new Date(user.createdAt).toLocaleString() : "—"}
        </Typography>
      </Box>
    </Box>
  );
};

export default AccountMetadataCard;
